// extracted by mini-css-extract-plugin
export default {"Cars":"Cars_Cars__rdonU","Cars__new":"Cars_Cars__new__uPKfn"};